import { devWarn } from "@/lib/logger";
import React, { useState } from "react";
import { Phone } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FloatingCallButton() {
  const [loading, setLoading] = useState(false);

  const handleClick = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      const r = await fetch(`${API}/call-number`);
      const data = await r.json();
      if (data?.number) {
        window.location.href = `tel:${data.number}`;
      }
    } catch (err) {
      devWarn("[call-button] failed", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      data-testid="floating-call-btn"
      onClick={handleClick}
      aria-label="Call support"
      className="fixed bottom-20 right-3 z-40 w-14 h-14 rounded-full bg-emerald-600 text-white shadow-xl grid place-items-center hover:scale-105 transition-transform"
      style={{ boxShadow: "0 10px 30px -8px rgba(15,81,50,0.55)" }}
    >
      <span className="absolute inset-0 rounded-full bg-emerald-500 animate-ping opacity-40" />
      <Phone size={24} className="relative" />
    </button>
  );
}
